// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__7oJIV","logo":"Main_logo__gsNUj","burger":"Main_burger__jOLPD"};